import React from "react";
import { Customer, ILeadActivity } from "../../../../core";
import { ActivityItem } from "./activity-item";
import { ChangeLogItem } from "./change-log-item";
import { FileItem } from "./file-item";
import { NoteItem } from "./note-item";

export class ActivityItemBuilder {
  static builder: {
    [type: string]: (
      activity: ILeadActivity,
      leadIds?: string[],
      onPressEdit?: () => void,
      customer?: Customer,
      onUpdateCustomer?: (id: string) => void,
      onReload?: () => void,
      companyId?: string,
      addActivity?: () => void,
      activityCategoryId?: string,
      activityCategory?: string,
    ) => {};
  } = {
      changeLog: (activity: ILeadActivity, leadIds, onPressEdit?: () => void) => {
        return <ChangeLogItem activity={activity} />;
      },
      note: (activity: ILeadActivity, leadIds, onPressEdit?: () => void) => {
        return <NoteItem activity={activity} />;
      },
      file: (activity: ILeadActivity, leadIds, onPressEdit?: () => void) => {
        return <FileItem activity={activity} />;
      },
      call: (
        activity: ILeadActivity,
        leadIds,
        onPressEdit?: () => void,
        customer?: Customer,
        onUpdateCustomer?: (id: string) => void,
        onReload?: () => void,
        companyId?: string,
        addActivity?: () => void,
        activityCategoryId?: string,
        activityCategory?: string,
      ) => {
        return (
          <ActivityItem
            addActivity={addActivity}
            onPressEdit={onPressEdit}
            leadIds={leadIds}
            activity={activity}
            onReload={onReload}
            companyId={companyId || ''}
            activityCategoryId={activityCategoryId || ''}
            activityCategory={activityCategory || ''}
          />
        );
      },
      meeting: (
        activity: ILeadActivity,
        leadIds,
        onPressEdit?: () => void,
        customer?: Customer,
        onUpdateCustomer?: (id: string) => void,
        onReload?: () => void,
        companyId?: string,
        addActivity?: () => void,
        activityCategoryId?: string,
        activityCategory?: string,
      ) => {
        return (
          <ActivityItem
            addActivity={addActivity}
            onPressEdit={onPressEdit}
            leadIds={leadIds}
            activity={activity}
            companyId={companyId || ''}
            activityCategoryId={activityCategoryId || ''}
            activityCategory={activityCategory || ''}
          />
        );
      },
      deadline: (
        activity: ILeadActivity,
        leadIds,
        onPressEdit?: () => void,
        customer?: Customer,
        onUpdateCustomer?: (id: string) => void,
        onReload?: () => void,
        companyId?: string,
        addActivity?: () => void,
        activityCategoryId?: string,
        activityCategory?: string,
      ) => {
        return (
          <ActivityItem
            addActivity={addActivity}
            onPressEdit={onPressEdit}
            leadIds={leadIds}
            activity={activity}
            companyId={companyId || ''}
            activityCategoryId={activityCategoryId || ''}
            activityCategory={activityCategory || ''}
          />
        );
      },
      task: (
        activity: ILeadActivity,
        leadIds,
        onPressEdit?: () => void,
        customer?: Customer,
        onUpdateCustomer?: (id: string) => void,
        onReload?: () => void,
        companyId?: string,
        addActivity?: () => void,
        activityCategoryId?: string,
        activityCategory?: string,
      ) => {
        return (
          <ActivityItem
            addActivity={addActivity}
            onPressEdit={onPressEdit}
            leadIds={leadIds}
            activity={activity}
            companyId={companyId || ''}
            activityCategoryId={activityCategoryId || ''}
            activityCategory={activityCategory || ''}
          />
        );
      },
      requestACallBack: (
        activity: ILeadActivity,
        leadIds,
        onPressEdit?: () => void,
        customer?: Customer,
        onUpdateCustomer?: (id: string) => void,
        onReload?: () => void,
        companyId?: string,
        addActivity?: () => void,
        activityCategoryId?: string,
        activityCategory?: string,
      ) => {
        return (
          <ActivityItem
            addActivity={addActivity}
            onPressEdit={onPressEdit}
            leadIds={leadIds}
            activity={activity}
            onReload={onReload}
            companyId={companyId || ''}
            activityCategoryId={activityCategoryId || ''}
            activityCategory={activityCategory || ''}
          />
        );
      },
      scheduleATestDrive: (
        activity: ILeadActivity,
        leadIds,
        onPressEdit?: () => void,
        customer?: Customer,
        onUpdateCustomer?: (id: string) => void,
        onReload?: () => void,
      ) => {
        return (
          <ActivityItem
            onPressEdit={onPressEdit}
            leadIds={leadIds}
            activity={activity}
            customer={customer}
            onUpdateCustomer={onUpdateCustomer}
            onReload={onReload}
          />
        );
      },
      activity: (
        activity: ILeadActivity,
        leadIds,
        onPressEdit?: () => void,
        customer?: Customer,
        onUpdateCustomer?: (id: string) => void,
        onReload?: () => void,
        companyId?: string,
        addActivity?: () => void,
        activityCategoryId?: string,
        activityCategory?: string,
      ) => {
        return (
          <ActivityItem
            addActivity={addActivity}
            onPressEdit={onPressEdit}
            leadIds={leadIds}
            activity={activity}
            companyId={companyId || ''}
            activityCategoryId={activityCategoryId || ''}
            activityCategory={activityCategory || ''}
          />
        );
      },
      scheduleASiteVisit: (
        activity: ILeadActivity,
        leadIds,
        onPressEdit?: () => void,
        customer?: Customer,
        onUpdateCustomer?: (id: string) => void,
        onReload?: () => void,
        companyId?: string,
        addActivity?: () => void,
        activityCategoryId?: string,
        activityCategory?: string,
      ) => {
        return (
          <ActivityItem
            addActivity={addActivity}
            onPressEdit={onPressEdit}
            leadIds={leadIds}
            activity={activity}
            companyId={companyId || ''}
            activityCategoryId={activityCategoryId || ''}
            activityCategory={activityCategory || ''}
          />
        );
      },
      showroomAppointment: (
        activity: ILeadActivity,
        leadIds,
        onPressEdit?: () => void,
        customer?: Customer,
        onUpdateCustomer?: (id: string) => void,
        onReload?: () => void,
      ) => {
        return (
          <ActivityItem
            onPressEdit={onPressEdit}
            leadIds={leadIds}
            activity={activity}
            customer={customer}
            onUpdateCustomer={onUpdateCustomer}
            onReload={onReload}
          />
        );
      },
      phoneIn: (
        activity: ILeadActivity,
        leadIds,
        onPressEdit?: () => void,
        customer?: Customer,
        onUpdateCustomer?: (id: string) => void,
        onReload?: () => void,
        companyId?: string,
        addActivity?: () => void,
        activityCategoryId?: string,
        activityCategory?: string,
      ) => {
        return (
          <ActivityItem
            addActivity={addActivity}
            onPressEdit={onPressEdit}
            leadIds={leadIds}
            activity={activity}
            companyId={companyId || ''}
            activityCategoryId={activityCategoryId || ''}
            activityCategory={activityCategory || ''}
          />
        );
      },
      phoneOut: (
        activity: ILeadActivity,
        leadIds,
        onPressEdit?: () => void,
        customer?: Customer,
        onUpdateCustomer?: (id: string) => void,
        onReload?: () => void,
        companyId?: string,
        addActivity?: () => void,
        activityCategoryId?: string,
        activityCategory?: string,
      ) => {
        return (
          <ActivityItem
            addActivity={addActivity}
            onPressEdit={onPressEdit}
            leadIds={leadIds}
            activity={activity}
            companyId={companyId || ''}
            activityCategoryId={activityCategoryId || ''}
            activityCategory={activityCategory || ''}
          />
        );
      },
      emailIn: (
        activity: ILeadActivity,
        leadIds,
        onPressEdit?: () => void,
        customer?: Customer,
        onUpdateCustomer?: (id: string) => void,
        onReload?: () => void,
        companyId?: string,
        addActivity?: () => void,
        activityCategoryId?: string,
        activityCategory?: string,
      ) => {
        return (
          <ActivityItem
            addActivity={addActivity}
            onPressEdit={onPressEdit}
            leadIds={leadIds}
            activity={activity}
            companyId={companyId || ''}
            activityCategoryId={activityCategoryId || ''}
            activityCategory={activityCategory || ''}
          />
        );
      },
      emailOut: (
        activity: ILeadActivity,
        leadIds,
        onPressEdit?: () => void,
        customer?: Customer,
        onUpdateCustomer?: (id: string) => void,
        onReload?: () => void,
        companyId?: string,
        addActivity?: () => void,
        activityCategoryId?: string,
        activityCategory?: string,
      ) => {
        return (
          <ActivityItem
            addActivity={addActivity}
            onPressEdit={onPressEdit}
            leadIds={leadIds}
            activity={activity}
            companyId={companyId || ''}
            activityCategoryId={activityCategoryId || ''}
            activityCategory={activityCategory || ''}
          />
        );
      },
      letterIn: (
        activity: ILeadActivity,
        leadIds,
        onPressEdit?: () => void,
        customer?: Customer,
        onUpdateCustomer?: (id: string) => void,
        onReload?: () => void,
        companyId?: string,
        addActivity?: () => void,
        activityCategoryId?: string,
        activityCategory?: string,
      ) => {
        return (
          <ActivityItem
            addActivity={addActivity}
            onPressEdit={onPressEdit}
            leadIds={leadIds}
            activity={activity}
            companyId={companyId || ''}
            activityCategoryId={activityCategoryId || ''}
            activityCategory={activityCategory || ''}
          />
        );
      },
      letterOut: (
        activity: ILeadActivity,
        leadIds,
        onPressEdit?: () => void,
        customer?: Customer,
        onUpdateCustomer?: (id: string) => void,
        onReload?: () => void,
        companyId?: string,
        addActivity?: () => void,
        activityCategoryId?: string,
        activityCategory?: string,
      ) => {
        return (
          <ActivityItem
            addActivity={addActivity}
            onPressEdit={onPressEdit}
            leadIds={leadIds}
            activity={activity}
            companyId={companyId || ''}
            activityCategoryId={activityCategoryId || ''}
            activityCategory={activityCategory || ''}
          />
        );
      },
      faxIn: (
        activity: ILeadActivity,
        leadIds,
        onPressEdit?: () => void,
        customer?: Customer,
        onUpdateCustomer?: (id: string) => void,
        onReload?: () => void,
        companyId?: string,
        addActivity?: () => void,
        activityCategoryId?: string,
        activityCategory?: string,
      ) => {
        return (
          <ActivityItem
            addActivity={addActivity}
            onPressEdit={onPressEdit}
            leadIds={leadIds}
            activity={activity}
            companyId={companyId || ''}
            activityCategoryId={activityCategoryId || ''}
            activityCategory={activityCategory || ''}
          />
        );
      },
      faxOut: (
        activity: ILeadActivity,
        leadIds,
        onPressEdit?: () => void,
        customer?: Customer,
        onUpdateCustomer?: (id: string) => void,
        onReload?: () => void,
        companyId?: string,
        addActivity?: () => void,
        activityCategoryId?: string,
        activityCategory?: string,
      ) => {
        return (
          <ActivityItem
            addActivity={addActivity}
            onPressEdit={onPressEdit}
            leadIds={leadIds}
            activity={activity}
            companyId={companyId || ''}
            activityCategoryId={activityCategoryId || ''}
            activityCategory={activityCategory || ''}
          />
        );
      },
      coldCalling: (
        activity: ILeadActivity,
        leadIds,
        onPressEdit?: () => void,
        customer?: Customer,
        onUpdateCustomer?: (id: string) => void,
        onReload?: () => void,
        companyId?: string,
        addActivity?: () => void,
        activityCategoryId?: string,
        activityCategory?: string,
      ) => {
        return (
          <ActivityItem
            addActivity={addActivity}
            onPressEdit={onPressEdit}
            leadIds={leadIds}
            activity={activity}
            companyId={companyId || ''}
            activityCategoryId={activityCategoryId || ''}
            activityCategory={activityCategory || ''}
          />
        );
      },
      todo: (
        activity: ILeadActivity,
        leadIds,
        onPressEdit?: () => void,
        customer?: Customer,
        onUpdateCustomer?: (id: string) => void,
        onReload?: () => void,
        companyId?: string,
        addActivity?: () => void,
        activityCategoryId?: string,
        activityCategory?: string,
      ) => {
        return (
          <ActivityItem
            addActivity={addActivity}
            onPressEdit={onPressEdit}
            leadIds={leadIds}
            activity={activity}
            companyId={companyId || ''}
            activityCategoryId={activityCategoryId || ''}
            activityCategory={activityCategory || ''}
          />
        );
      },
    };
}
